import React from 'react';
import PropTypes from 'prop-types';
import {
  TextField, ThemeProvider
} from '@material-ui/core';
import { RedAsterisk } from '../../providers/MuiTheme';
import uuid from '../../_helpers/uuid';

const InputDate = (props) => {
  const {
    disabled,
    type,
    label,
    id,
    fullWidth,
    hidden,
    inputProps,
    invalid,
    onChange,
    readOnly,
    required,
    value,
    variant,
    name
  } = props;

  return (
    <ThemeProvider theme={RedAsterisk}>
      <TextField
        type={type}
        disabled={disabled}
        InputLabelProps={{
          shrink: true,
        }}
        label={label}
        id={id || uuid()}
        variant={variant}
        hidden={hidden}
        fullWidth={fullWidth}
        inputProps={inputProps}
        error={invalid}
        name={name}
        onChange={onChange}
        readOnly={readOnly}
        value={value}
        required={required}
      />
    </ThemeProvider>
  );
};
InputDate.propTypes = {
  disabled: PropTypes.bool,
  type: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string,
  fullWidth: PropTypes.bool,
  hidden: PropTypes.bool,
  inputProps: PropTypes.objectOf(PropTypes.any),
  invalid: PropTypes.bool,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  value: PropTypes.string,
  variant: PropTypes.string,
  name: PropTypes.string.isRequired
};
InputDate.defaultProps = {
  disabled: false,
  type: 'date',
  label: 'No Label Provided',
  id: undefined,
  fullWidth: true,
  hidden: false,
  inputProps: {},
  invalid: false,
  onChange: () => {},
  readOnly: false,
  required: false,
  value: '',
  variant: undefined
};
export default InputDate;
